import { render, staticRenderFns } from "./GridListas.vue?vue&type=template&id=2d02c787"
import script from "./GridListas.vue?vue&type=script&setup=true&lang=js"
export * from "./GridListas.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports